import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faQuestion, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import axios from "axios";
import { BAlert, BButton, BCard, BFormInput, BInputGroup, BInputGroupAppend, BTable } from "bootstrap-vue";
import { computed, ref, watch } from "vue";
import { useRouter } from "vue-router/composables";
import { getRedirectOnImportPath } from "@/components/Workflow/redirectPath";
import { Services } from "@/components/Workflow/services";
import { withPrefix } from "@/utils/redirect";
import LoadingSpan from "@/components/LoadingSpan.vue";
import TrsServerSelection from "@/components/Workflow/Import/TrsServerSelection.vue";
import TrsTool from "@/components/Workflow/Import/TrsTool.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'TrsSearch',
    setup(__props) {
        library.add(faQuestion, faTimes);
        const fields = [
            { key: "name", label: "Name" },
            { key: "description", label: "Description" },
            { key: "organization", label: "Organization" },
        ];
        const query = ref("");
        const results = ref([]);
        const trsServer = ref("");
        const loading = ref(false);
        const importing = ref(false);
        const trsSelection = ref(null);
        const errorMessage = ref(null);
        const hasErrorMessage = computed(() => {
            return errorMessage.value != null;
        });
        const itemsComputed = computed(() => {
            return computeItems(results.value);
        });
        const searchHelp = computed(() => {
            return "Search by workflow description. Tags (key:value) can be used to also search by metadata - for instance name:example. Available tags include organization and name.";
        });
        const services = new Services();
        watch(query, async () => {
            if (query.value == "") {
                results.value = [];
            }
            else {
                loading.value = true;
                try {
                    const response = await axios.get(withPrefix(`/api/trs_search?query=${query.value}&trs_server=${trsServer.value}`));
                    results.value = response.data;
                }
                catch (e) {
                    errorMessage.value = e;
                }
                loading.value = false;
            }
        });
        function onTrsSelection(selection) {
            trsSelection.value = selection;
            trsServer.value = selection.id;
            query.value = "";
        }
        function onTrsSelectionError(message) {
            errorMessage.value = message;
        }
        function showRowDetails(row, index, e) {
            if (e.target?.nodeName !== "A") {
                row._showDetails = !row._showDetails;
            }
        }
        function computeItems(items) {
            return items.map((item) => {
                return {
                    id: item.id,
                    name: item.name,
                    description: item.description,
                    data: item,
                    _showDetails: false,
                };
            });
        }
        const router = useRouter();
        async function importVersion(trsId, toolIdToImport, version, isRunFormRedirect = false) {
            if (!trsId || !toolIdToImport) {
                errorMessage.value = "Import Failed. Unknown Id";
                return;
            }
            importing.value = true;
            errorMessage.value = null;
            try {
                const response = await services.importTrsTool(trsId, toolIdToImport, version);
                const path = getRedirectOnImportPath(response, isRunFormRedirect);
                router.push(path);
            }
            catch (e) {
                errorMessage.value = e || "Import failed for an unknown reason.";
            }
            importing.value = false;
        }
        return { __sfc: true, fields, query, results, trsServer, loading, importing, trsSelection, errorMessage, hasErrorMessage, itemsComputed, searchHelp, services, onTrsSelection, onTrsSelectionError, showRowDetails, computeItems, router, importVersion, faQuestion, faTimes, FontAwesomeIcon, BAlert, BButton, BCard, BFormInput, BInputGroup, BInputGroupAppend, BTable, LoadingSpan, TrsServerSelection, TrsTool };
    }
});
